import { TLLBoardActions } from './ll-board.actions';
import { TLLBoardInfoActionType, TLLBoardState } from './ll-board.models';

export const initialState: TLLBoardState = {
  lineShiftInfo: null,
  llBoardList: null,
  loadStripOnMouse: null,
  llTaskManager: null,
  learningCurveStripInfo: null,
  learningCurveByFactoryOtl: null,
  lineStripListingInfo: null,
  lineStripPlannedNumbers: null,
  llPCDPEDThreshold: null,
  planVersions: [],
  selectedPlanVersion: null,
  isCreatingPlanVersion: false,
  isPromotingPlanVersion: false,
};

export function llBoardReducer(state = initialState, action: TLLBoardActions): TLLBoardState {
  switch (action.type) {
    case TLLBoardInfoActionType.GetLLBoardListSuccess:
      return {
        ...state,
        llBoardList: action.payload,
      };
    case TLLBoardInfoActionType.GetLineShiftInfo:
      return {
        ...state,
        lineShiftInfo: null,
      };
    case TLLBoardInfoActionType.GetLineShiftInfoSuccess:
      return {
        ...state,
        lineShiftInfo: action.lineShiftRes,
      };
    case TLLBoardInfoActionType.SetLoadStripOnMouse:
      return {
        ...state,
        loadStripOnMouse: action.loadStrip,
      };

    case TLLBoardInfoActionType.GetLLBoardTaskManagerSuccess:
      return {
        ...state,
        llTaskManager: action.res,
      };
    case TLLBoardInfoActionType.GetLearningCurveStripeInfoSuccess:
      return {
        ...state,
        learningCurveStripInfo: action.learningCurveStripRes,
      };
    case TLLBoardInfoActionType.GetLearningCurveByFactoryOtlSuccess:
      return {
        ...state,
        learningCurveByFactoryOtl: action.learningCurveFactoryOtlRes,
      };
    case TLLBoardInfoActionType.GetLineStripListingSuccess:
      return {
        ...state,
        lineStripListingInfo: action.lineStripListingRes,
      };
    case TLLBoardInfoActionType.LineStripPlannedNumbersSuccess:
      return {
        ...state,
        lineStripPlannedNumbers: action.stripPlannedNumbers,
      };
    case TLLBoardInfoActionType.SetLLPCDPEDThreshold:
      return {
        ...state,
        llPCDPEDThreshold: action.addPCDPEDThresholds,
      };
    case TLLBoardInfoActionType.LoadPlanVersionsSuccess: {
      const keptVersion = action.versions.find((version) => version.versionId === action.keepVersionId);
      const liveVersion = action.versions.find((version) => version.versionType === 'LIVE');
      return {
        ...state,
        planVersions: action.versions,
        selectedPlanVersion: (keptVersion ?? liveVersion ?? action.versions[0])?.versionId ?? null,
      };
    }
    case TLLBoardInfoActionType.SetPlanVersions:
      return {
        ...state,
        planVersions: action.versions,
      };
    case TLLBoardInfoActionType.SetSelectedPlanVersion:
      return {
        ...state,
        selectedPlanVersion: action.versionId,
      };
    case TLLBoardInfoActionType.SetIsCreatingPlanVersion:
      return {
        ...state,
        isCreatingPlanVersion: action.isCreating,
      };
    case TLLBoardInfoActionType.SetIsPromotingPlanVersion:
      return {
        ...state,
        isPromotingPlanVersion: action.isPromoting,
      };
    default:
      return state;
  }
}
